import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  calculationUnitsFilteredList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  groupsFilteredList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  metricsGroupsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  metricsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  modelsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  exportConfigurationsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  saveCurrentConfiguration: ReducersTooling.initialStates.getFetchTypeInitialState(),
  deleteConfiguration: ReducersTooling.initialStates.getFetchTypeInitialState(),
  polynomialsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  biTemplatesList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  periodsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  exportData: ReducersTooling.initialStates.getFetchTypeInitialState(),
};

export default initialState;


// WEBPACK FOOTER //
// ./source/client/reducers/exportConfigurationsAdmin/initialState.js